import { actionCreator } from 'utils';
import {
    LOAD_COATING_IN,
    START_PALETTE,
    LOAD_JOB_PALETTES_TO_START,
    SET_EMPTY_START_PALETTE,
} from '../types/coatingInTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    limit: 50,
    offset: 0,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {},
    startPalette: {
        loading: false,
        error: false,
        success: false,
    },
    jobPalettes: {
        loading: false,
        error: false,
        listing: null,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_COATING_IN:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_COATING_IN, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_COATING_IN, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case LOAD_JOB_PALETTES_TO_START:
        return Object.assign({}, state, {
            jobPalettes: Object.assign({}, state.jobPalettes, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_JOB_PALETTES_TO_START, 'res'):
        return Object.assign({}, state, {
            jobPalettes: Object.assign({}, state.jobPalettes, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(LOAD_JOB_PALETTES_TO_START, 'err'):
        return Object.assign({}, state, {
            jobPalettes: Object.assign({}, state.jobPalettes, {
                error: true,
                loading: false,
            }),
        });

    case START_PALETTE:
        return Object.assign({}, state, {
            startPalette: Object.assign({}, state.startPalette, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(START_PALETTE, 'res'):
        return Object.assign({}, state, {
            startPalette: Object.assign({}, state.startPalette, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(START_PALETTE, 'err'):
        return Object.assign({}, state, {
            startPalette: Object.assign({}, state.startPalette, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case SET_EMPTY_START_PALETTE:
        return Object.assign({}, state, {
            jobPalettes: Object.assign({}, state.jobPalettes, {
                loading: false,
                error: false,
                listing: null,
            }),
        });

    default:
        return state;
    }
}
